module.exports = __webpack_public_path__ + "media/Daughter-in-law.36b219a7.mp3";